import React, { useState } from 'react';
import Bredcrum from '../../common/Bredcrum';
import CourseOverview from './CourseOverview';
import CourseList from './CourseList';

const CoursesIndex = () => {
  const [sortType, setSortType] = useState('low-high');
  const [sortDirection, setSortDirection] = useState('ascending');
  const [transmissionType, setTransmissionType] = useState('all');

  return (
    <>
      <Bredcrum
        heading={'Our Courses'}
        path={[{ name: 'Courses', path: 'courses' }]}
      />

      <section className="py-4">
        <div className="auto-container">
          <div className="row g-3 align-items-end">
            <div className="col-lg-4 col-md-6">
              <label className="fw-bold d-block mb-2">Sort type</label>
              <select
                className="form-select"
                value={sortType}
                onChange={(e) => setSortType(e.target.value)}
              >
                <option value="low-high">Low - High Prices</option>
                <option value="high-low">High - Low Prices</option>
              </select>
            </div>
            <div className="col-lg-4 col-md-6">
              <label className="fw-bold d-block mb-2">Sort order</label>
              <select
                className="form-select"
                value={sortDirection}
                onChange={(e) => setSortDirection(e.target.value)}
              >
                <option value="ascending">Ascending</option>
                <option value="descending">Descending</option>
              </select>
            </div>
            <div className="col-lg-4 col-md-6">
              <label className="fw-bold d-block mb-2">Transmission</label>
              <select
                className="form-select"
                value={transmissionType}
                onChange={(e) => setTransmissionType(e.target.value)}
              >
                <option value="all">All</option>
                <option value="manual">Manual</option>
                <option value="automatic">Automatic</option>
              </select>
            </div>
          </div>
        </div>
      </section>

      <CourseOverview />
      <CourseList
        sortType={sortType}
        sortDirection={sortDirection}
        transmissionType={transmissionType}
      />
    </>
  );
};

export default CoursesIndex;
